import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import permission from './modules/permission'
import user from './modules/user'
import setting from './modules/setting'

import getters from './getters'

Vue.use(Vuex)

const modules: any = {
	app,
	permission,
	user,
	setting,
}

const store = new Vuex.Store({
	modules,
	getters,
})

export default store
